export const STAGE_EXPERIMENT_KEY = 'stage';
export const NEW_USER_DATE = '09-03-2024';
